/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'

import {
  EmploymentNotification,
  readNotificationEmployment,
} from '@builddocs/data-management'
import {
  Divider,
  ListItem,
  ListItemButton,
  Stack,
  Typography,
  Avatar,
  Alert,
  AlertTitle,
} from '@mui/material'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'
import { RefetchOptions, RefetchQueryFilters } from 'react-query'

import { EmploymentBody } from './EmploymentBody'

interface OwnProps {
  employment: EmploymentNotification
  setUnreadCount: Dispatch<SetStateAction<number>>
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => void
  last: boolean
}

export type EmploymentItemProps = OwnProps

const EmploymentItem: FC<EmploymentItemProps> = props => {
  const { employment, setUnreadCount, last, refetch } = props
  const [avatar] = useState<string>('')
  const [viewed, setViewed] = useState<boolean>(employment.viewed)
  const [isUnknown, setIsUnknown] = useState<boolean>(false)

  const initialDividerStyle = {
    position: 'absolute',
    width: '100%',
    transition: theme =>
      theme.transitions.create(['opacity'], {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),
  }

  const handleRead = () => {
    if (!viewed) {
      readNotificationEmployment([employment.notificationId])
      setUnreadCount(count => count - 1)
      setViewed(true)
    }
  }

  // useEffect(() => {
  //   getAvatarSource(employment.senderId).then(avatar => setAvatar(avatar))
  // }, [])

  useEffect(() => {
    setViewed(employment.viewed)
  }, [employment.viewed])

  if (isUnknown)
    return (
      <Alert severity="error">
        <AlertTitle>Неизвестный тип уведомления</AlertTitle>
        Невозможно отобразить данный компонент
      </Alert>
    )

  return (
    <ListItem
      key={employment.businessKey}
      disablePadding
      sx={{
        '&:hover, &:focus': { '& hr': { opacity: 0 } },
      }}
      onMouseEnter={handleRead}
      onTouchStart={handleRead}
    >
      <ListItemButton
        alignItems="flex-start"
        sx={{
          p: 1,
          '&:hover, &:focus': { '& div': { opacity: 1 } },
        }}
      >
        <Divider sx={{ ...initialDividerStyle, top: 0, left: 0 }} />
        <Stack direction="row" gap={2} px={2} width="100%">
          <Avatar src={avatar} sx={{ alignSelf: 'center' }} />
          <Stack direction="column" gap={1}>
            <EmploymentBody
              employment={{ ...employment, viewed }}
              refetch={refetch}
              setIsUnknown={setIsUnknown}
            />
            <Typography
              color="text.secondary"
              variant="caption"
              whiteSpace="nowrap"
            >
              {format(new Date(employment.createDateTime + 'Z'), 'p, PPP', {
                locale: ru,
              })}
            </Typography>
          </Stack>
        </Stack>
        {last && (
          <Divider sx={{ ...initialDividerStyle, bottom: 0, left: 0 }} />
        )}
      </ListItemButton>
    </ListItem>
  )
}

export default EmploymentItem
